import { toast } from "react-toastify";
import React, { useReducer } from "react";
import ProductContext from "./productContext";
import { favouriteReducer } from "./productReducer";
import {
  ADD_PRODUCT_COUNT,
  ADD_TO_CART,
  LOAD_CART,
  LOAD_PRODUCTS,
  REMOVE_FROM_CART,
  REMOVE_PRODUCT_COUNT,
} from "./types";

const data = require("../../data.json");

const ProductState = ({ children }) => {
  const initialState = {
    products: [],
    cartProducts: [],
    totalItems: 0,
    totalCost: 0,
    totalCostAfterTask: 0,
  };

  const [state, dispatch] = useReducer(favouriteReducer, initialState);

  //simulate data fetching
  const loadProducts = async () => {
    const products = await new Promise((resolve, reject) => {
      resolve(data);
    });

    dispatch({ type: LOAD_PRODUCTS, payload: products });
  };

  const loadCart = () => dispatch({ type: LOAD_CART });

  const addToCart = productId => dispatch({ type: ADD_TO_CART, payload: productId });

  const removeFromCart = productId => {
    dispatch({ type: REMOVE_FROM_CART, payload: productId });
    toast.info(`Product ${productId} removed from cart`);
  };

  const addCount = productId => dispatch({ type: ADD_PRODUCT_COUNT, payload: productId });

  const removeCount = (productId, value) =>
    value - 1 <= 0
      ? removeFromCart(productId)
      : dispatch({ type: REMOVE_PRODUCT_COUNT, payload: productId });

  return (
    <ProductContext.Provider
      value={{
        products: state.products,
        totalCost: state.totalCost,
        totalItems: state.totalItems,
        cartProducts: state.cartProducts,
        totalCostAfterTax: state.totalCostAfterTax,

        loadCart,
        addCount,
        addToCart,
        removeCount,
        loadProducts,
        removeFromCart,
      }}
    >
      {children}
    </ProductContext.Provider>
  );
};

export default ProductState;
